import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "authTypeSelect",
    "authConfigSection",
    "secretFieldsContainer",
    "configFieldsContainer",
    "customHeadersContainer",
    "secretFieldTemplate",
    "configFieldTemplate",
    "customHeaderTemplate",
    "nameInput",
    "keyInput",
    "urlFields",
    "useConfigEndpointToggle"
  ]

  connect() {
    this.syncAuthConfigSections()
    this.syncUrlFieldsVisibility()
  }

  authTypeChanged() {
    this.syncAuthConfigSections()
  }

  syncAuthConfigSections() {
    const authType = this.authTypeSelectTarget?.value

    this.authConfigSectionTargets.forEach((section) => {
      const show = section.dataset.authType === authType
      section.classList.toggle("hidden", !show)

      section.querySelectorAll("input, select, textarea, button").forEach((el) => {
        el.disabled = !show
      })
    })
  }

  // Auto-slug: populate key from name when creating a new provider.
  slugifyName() {
    if (!this.hasKeyInputTarget) return
    // Only auto-fill if the key field is not readonly (new record)
    if (this.keyInputTarget.readOnly || this.keyInputTarget.disabled) return

    const slug = this.nameInputTarget.value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
    this.keyInputTarget.value = slug
  }

  useConfigEndpointChanged() {
    this.syncUrlFieldsVisibility()
  }

  syncUrlFieldsVisibility() {
    if (!this.hasUseConfigEndpointToggleTarget) return
    const useConfig = this.useConfigEndpointToggleTarget.checked

    this.urlFieldsTargets.forEach((el) => {
      el.classList.toggle("hidden", useConfig)
      el.querySelectorAll("input, select").forEach((input) => {
        input.disabled = useConfig
      })
    })
  }

  addSecretField() {
    const node = this.secretFieldTemplateTarget.content.cloneNode(true)
    this.secretFieldsContainerTarget.appendChild(node)
    this._hideEmptyState(this.secretFieldsContainerTarget)
  }

  addConfigField() {
    const node = this.configFieldTemplateTarget.content.cloneNode(true)
    this.configFieldsContainerTarget.appendChild(node)
    this._hideEmptyState(this.configFieldsContainerTarget)
  }

  addCustomHeader() {
    const node = this.customHeaderTemplateTarget.content.cloneNode(true)
    this.customHeadersContainerTarget.appendChild(node)
    this._hideEmptyState(this.customHeadersContainerTarget)
  }

  removeRow(event) {
    const row = event.currentTarget.closest(".integration-provider-row")
    row?.remove()
  }

  _hideEmptyState(container) {
    const empty = container.querySelector("[data-empty-state]")
    if (empty) empty.classList.add("hidden")
  }
}
